<template>
  <div class="message">
    <!-- 面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>公告</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="main">
      <!-- 头部查询 -->
      <div slot="header" class="clearfix">
        <span>
          <b style="font-size:14px">公告</b>
        </span>
      </div>
      <!-- 表格 -->
      <el-table :data="msgData" style="width: 100%" @row-click="openMsg">
        <!-- <el-table-column label="#" type="index" width="150"></el-table-column> -->
        <el-table-column label="标题">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false">{{scope.row.title}}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="发件人" prop="sender" width="150"></el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | dateformat }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 40,60, 80,100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
      <el-dialog :title="seeTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
        <div class="text" v-html="safeContent"></div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
//引入api
import httpApi from "@/http/api";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
export default {
  data() {
    return {
      msgData: [], //全局公告信
      currentPage: 1, //分页初始页
      pagesize: 20, //分页每页数据
      total: 0, //分页总数
      seeTitle: "",
      dialogFormVisible: false,
      test: ""
    };
  },
  computed: {
    safeContent() {
      return sanitizeHtml(this.test);
    }
  },
  methods: {
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function(size) {
      this.pagesize = size;
      this.currentPage = 1;
      //每页下拉显示数据
      this.setMsg();
    },
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
      //点击第几页
      this.setMsg();
    },
    openMsg(row) {
      this.dialogFormVisible = true;
      this.seeTitle = row.title;
      this.test = row.content;
    },
    setMsg() {
      let that = this;
      httpApi
        .queryMsg( {
          params: {
            page: that.currentPage,
            rows: that.pagesize,
            hasread: "",
            type: "1"
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.msgData = res.data.data.rows;
            that.total = res.data.data.total;
          } else {
            that.$message.error(res.data.message);
          }
        });
    }
  },
  created() {
    this.setMsg();
  }
};
</script>

<style lang="less" scoped>
/deep/.el-card__body {
  padding: 0px 20px 20px;
}
.clearfix {
  text-align: left;
  margin-left: -10px;
  span,
  div,
  button {
    margin-left: 20px;
  }
}
/deep/.block {
  margin-top: 20px;
  text-align: center;
}
/deep/.text {
  text-align: left;
  p {
    margin: 8px 0;
  }
}
</style>